export default "__VITE_ASSET__09de8814__"